<div
    class="report-card-benchmark-component"
    [style.min-width]="pdfMode ? '180px' : '224px'"
    fxLayout="column"
>
    <div
        class="report-card-benchmark-component_card-header"
        [class.gap-8]="!pdfMode"
        [class.gap-4]="pdfMode"
        fxLayout="column"
    >
        <div fxLayout="column" fxFlex>
            <span
                class="color-text-primary"
                [class]="pdfMode ? 'text-10-semi-bold' : 'text-14-semi-bold'"
                >{{ benchmark.props.serie.name }}</span
            >
            <span
                class="color-text-primary"
                [class]="pdfMode ? 'text-10-regular' : 'text-14-regular'"
                >Fonte: {{ benchmark.sourceLabel }}</span
            >
        </div>
        @if (benchmark.positionResult.formatted !== "sem dados") {
            <span
                class="color-text-primary"
                [class]="pdfMode ? 'text-10-regular' : 'text-14-regular'"
                >Resultado
                <span
                    [class]="
                        pdfMode ? 'text-10-semi-bold' : 'text-14-semi-bold'
                    "
                    class="card-benchmark__rankNumber"
                    [class.color-text-cyan-primary]="
                        benchmark.positionResult.polarityColor === 'cyan.dark'
                    "
                    [class.color-text-purple-primary]="
                        benchmark.positionResult.polarityColor === 'purple.dark'
                    "
                    [class.color-text-petroleum]="
                        benchmark.positionResult.polarityColor ===
                        'petroleum.medium'
                    "
                >
                    {{ benchmark.positionResult.formatted }}</span
                >
                @if (benchmark.positionResult.value != 50) {
                    da média do mercado.
                } @else {
                    na média do mercado.
                }
            </span>
        } @else {
            <span
                class="color-text-primary"
                [class]="pdfMode ? 'text-10-regular' : 'text-14-regular'"
            >
                Sem dados para comparação.
            </span>
        }
    </div>
    <div
        class="report-card-benchmark-component_card-infos report-card-benchmark-component_row"
        fxLayout="row"
        fxFlex
    >
        <div
            class="info-card disabled"
            style="gap: 2px"
            fxLayout="column"
            fxFlex
        >
            <span [class]="pdfMode ? 'text-8-regular' : 'text-12-regular'">
                Sua empresa
            </span>
            <span fxFlex></span>
            <span
                [class]="pdfMode ? 'text-10-bold' : 'text-16-bold'"
                style="white-space: nowrap"
            >
                {{ benchmark.currentResult.formatted }}
            </span>
        </div>
        <div class="info-card cyan-light" fxLayout="column" fxFlex>
            <span [class]="pdfMode ? 'text-8-regular' : 'text-12-regular'">
                Média do mercado
            </span>
            <span fxFlex></span>
            @if (!locked) {
                <span
                    [class]="pdfMode ? 'text-10-bold' : 'text-16-bold'"
                    style="white-space: nowrap"
                >
                    {{ benchmark.benchmarkingResult.formatted }}
                </span>
            } @else {
                <i
                    class="fa-solid fa-lock color-text-primary"
                    [style]="
                        pdfMode
                            ? 'font-size: var(--font-size-12)'
                            : 'font-size: var(--font-size-16)'
                    "
                ></i>
            }
        </div>
    </div>
</div>
